import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import { injectIntl, defineMessages } from 'react-intl';

import NumberDataPod from '../../../components/NumberDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.transfer.credit-cap.title',
    defaultMessage: 'Transfer Credit Cap',
  },
  text: {
    id: 'hubs.transfer.credit-cap.text',
    defaultMessage: `Maximum number of credits students can transfer to this college`,
  },
});

const TransferCreditCap = ({ intl, transferAdmissions }) => {
  const value = get(transferAdmissions, 'creditCap.value');
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');

  return (
    !Number.isNaN(+value) &&
    +value > 0 && (
      <NumberDataPod
        header={intl.formatMessage(messages.title)}
        footer={lastUpdated}
        ariaLabel={`Transfer Credit Cap, ${value}`}
        content={{
          value: +value,
          text: intl.formatMessage(messages.text),
        }}
      />
    )
  );
};
TransferCreditCap.propTypes = {
  intl: PropTypes.object,
  transferAdmissions: PropTypes.object,
};

export default injectIntl(TransferCreditCap);
